// «Настройки»: аккаунт и способы входа, политика конфиденциальности, удаление аккаунта со всеми данными.
import { useEffect, useState } from "react";
import { boot } from "../boot";
import { Icon } from "../components/Icon";
import { deleteAccount, loadMe, logout, PROVIDERS, type Me } from "../lib/account";
import { openLogin } from "../store";

const longDate = (iso: string) => new Date(iso).toLocaleDateString("ru-RU", { day: "numeric", month: "long", year: "numeric" });

export function SettingsPage() {
  const [me, setMe] = useState<Me | null>(null);
  useEffect(() => { loadMe().then(setMe).catch(() => setMe(null)); }, []);
  const user = boot.user;
  return (
    <div className="settings-page">
      <h1>Настройки</h1>

      <section className="settings-card" aria-labelledby="settings-account">
        <h2 id="settings-account">Аккаунт</h2>
        {user ? (
          <dl className="settings-facts">
            {user.name && <><dt>Имя</dt><dd>{user.name}</dd></>}
            <dt>Почта</dt><dd>{user.email || "—"}</dd>
            <dt>Вход</dt>
            <dd>{me ? me.logins.map((login) => PROVIDERS[login.provider] || login.provider).join(", ") || "—" : "…"}</dd>
            {me && <><dt>Аккаунт создан</dt><dd>{longDate(me.created_at)}</dd></>}
          </dl>
        ) : (
          <div className="settings-guest">
            <p>Вы работаете как гость: чаты, документы и расчёты привязаны к этому браузеру. Войдите — всё сохранённое перейдёт в аккаунт и будет открываться с любого устройства.</p>
            <button type="button" className="docs-button is-primary" onClick={() => openLogin()}><Icon name="login" />Войти или зарегистрироваться</button>
          </div>
        )}
        {user && <button type="button" className="docs-button" onClick={logout}><Icon name="logout" />Выйти из аккаунта</button>}
      </section>

      <section className="settings-card" aria-labelledby="settings-privacy">
        <h2 id="settings-privacy">Конфиденциальность</h2>
        <p>Какие данные хранит Правосвод, зачем и как их удалить.</p>
        <a className="docs-button" href="/privacy"><Icon name="shield" />Политика конфиденциальности</a>
      </section>

      <section className="settings-card is-danger" aria-labelledby="settings-delete">
        <h2 id="settings-delete">Удаление аккаунта</h2>
        <p>Удалятся все чаты, собранные документы, расчёты, загруженные файлы и папки, а также сведения о входе. Отменить это нельзя.</p>
        <button type="button" className="docs-button is-danger" onClick={deleteAccount}><Icon name="trash" />Удалить аккаунт и все данные</button>
      </section>
    </div>
  );
}
